import { render, staticRenderFns } from "./RedeliveryCalculation.vue?vue&type=template&id=83966950&"
import script from "./RedeliveryCalculation.vue?vue&type=script&lang=js&"
export * from "./RedeliveryCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports